/* BEME "Liquid Glass" JS v3.0 — one file for all sections. No dependencies. */
(function () {
  "use strict";
  if (window.__bemeLoaded) return; /* loaded twice (e.g. theme.liquid + header) would double every add */
  window.__bemeLoaded = true;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  if (rootUrl.charAt(rootUrl.length - 1) !== "/") rootUrl += "/";

  /* ---------- unified panel system (sheets, drawers, spotlight) ---------- */
  var overlay = $("[data-b-overlay]");
  var openPanel = null;
  var lastFocus = null;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';

  /* remember the control the shopper used last, so focus can go back to it on close */
  var lastActive = null;
  document.addEventListener("focusin", function (e) {
    if (!openPanel || !openPanel.contains(e.target)) lastActive = e.target;
  });

  function lockScroll(on) {
    var de = document.documentElement;
    de.classList.toggle("b-panel-open", !!on);
    if (on) {
      var sw = window.innerWidth - de.clientWidth;
      de.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      if (sw > 0) document.body.style.paddingRight = sw + "px";
    } else {
      de.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }
  }

  function open(name) {
    var p = $('[data-b-panel="' + name + '"]');
    if (!p) {
      /* the standalone BEME Cart Drawer section handles the cart itself */
      if (name === "cart") { if (window.BCD) window.BCD.open(); else window.location.href = rootUrl + "cart"; }
      return;
    }
    if (openPanel === p) return; /* already open: no flicker */
    $$("[data-b-nav]").forEach(function (n) { if (n.__bHide) n.__bHide(); });
    if (!openPanel) {
      var ae = document.activeElement;
      lastFocus = ae && ae !== document.body && !ae.disabled ? ae : lastActive;
    }
    close(true);
    p.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (openPanel !== p) return;
        p.classList.add("is-open");
        if (overlay) overlay.classList.add("is-open");
      });
    });
    lockScroll(true);
    openPanel = p;
    if (name === "search") {
      var f = $("input[type=search]", p);
      if (f) setTimeout(function () { f.focus(); }, 120);
    } else {
      setTimeout(function () {
        if (openPanel !== p) return;
        if (!p.hasAttribute("tabindex")) p.setAttribute("tabindex", "-1");
        p.focus({ preventScroll: true });
      }, 60);
    }
    $$('[data-b-open="' + name + '"]').forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
  }

  function close(instant) {
    if (!openPanel) return;
    var p = openPanel;
    openPanel = null;
    p.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    lockScroll(false);
    var done = function () {
      if (!p.classList.contains("is-open")) p.hidden = true;
      if (overlay && !overlay.classList.contains("is-open")) overlay.hidden = true;
    };
    instant === true ? done() : setTimeout(done, 400);
    $$("[data-b-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
    if (instant !== true && lastFocus && lastFocus.focus && document.contains(lastFocus)) {
      lastFocus.focus({ preventScroll: true });
      lastFocus = null;
    }
  }

  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-b-open]");
    if (o) { e.preventDefault(); open(o.getAttribute("data-b-open")); return; }
    if (e.target.closest("[data-b-close]")) { e.preventDefault(); close(); return; }
    if (overlay && e.target === overlay) close();
    if (openPanel && openPanel.classList.contains("b-spot") && e.target === openPanel) close();
    if (openPanel && openPanel.classList.contains("b-sheet") && e.target === openPanel) close();
  });
  document.addEventListener("keydown", function (e) {
    if (!openPanel) return;
    if (e.key === "Escape") { close(); return; }
    /* keep keyboard focus inside the open panel */
    if (e.key === "Tab") {
      var items = $$(FOCUSABLE, openPanel).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === openPanel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- bottom-sheet drag to close (delegated: keeps working after the cart re-renders) ---------- */
  var drag = null;
  document.addEventListener("pointerdown", function (e) {
    var handle = e.target.closest && e.target.closest("[data-b-drag]");
    if (!handle) return;
    var sheet = handle.closest(".b-sheet, .b-drawer");
    if (!sheet) return;
    var panel = handle.closest(".b-sheet__panel") || sheet;
    drag = { handle: handle, sheet: sheet, panel: panel, y: e.clientY, dy: 0 };
    sheet.classList.add("is-dragging");
    panel.style.transition = "none";
    try { handle.setPointerCapture(e.pointerId); } catch (err) {}
  });
  document.addEventListener("pointermove", function (e) {
    if (!drag) return;
    drag.dy = Math.max(0, e.clientY - drag.y);
    drag.panel.style.transform = "translateY(" + drag.dy + "px)";
  });
  function endDrag() {
    if (!drag) return;
    var d = drag;
    drag = null;
    d.sheet.classList.remove("is-dragging");
    d.panel.style.transition = "";
    if (d.dy > 90 || d.dy < 8) {
      /* dragged far enough, or a simple tap on the handle */
      close();
      requestAnimationFrame(function () { d.panel.style.transform = ""; });
    } else {
      d.panel.style.transform = "";
    }
  }
  document.addEventListener("pointerup", endDrag);
  document.addEventListener("pointercancel", endDrag);
  document.addEventListener("click", function (e) {
    /* keyboard "click" on the handle (no pointer) */
    if (e.detail === 0 && e.target.closest && e.target.closest("[data-b-drag]")) close();
  });

  /* ---------- fixed pill header (CSS sticky can't escape Horizon's #header-group,
     so we pin with position:fixed past the header's natural offset + a spacer) ---------- */
  var headwrap = $("[data-b-header]");
  if (headwrap) {
    var sticky = headwrap.classList.contains("is-sticky");
    var spacer = document.createElement("div");
    var headTop = 0;
    if (sticky) headwrap.after(spacer);
    var measure = function () {
      if (!sticky) return;
      var wasFixed = headwrap.classList.contains("is-fixed");
      if (wasFixed) { headwrap.classList.remove("is-fixed"); spacer.style.height = "0px"; }
      headTop = headwrap.getBoundingClientRect().top + window.scrollY;
      if (wasFixed) apply();
    };
    var transparent = headwrap.classList.contains("b-headwrap--transparent");
    if (transparent) {
      var annEl = $("[data-b-announce]");
      var setAnnH = function () {
        headwrap.style.setProperty("--b-ann-h", (annEl ? annEl.offsetHeight : 0) + "px");
      };
      setAnnH();
      window.addEventListener("resize", setAnnH, { passive: true });
    }
    var lastY = 0;
    var apply = function () {
      var y = window.scrollY;
      var fixNow = sticky && y > headTop + (transparent ? headwrap.offsetHeight + 40 : 0);
      if (fixNow !== headwrap.classList.contains("is-fixed")) {
        if (!transparent) spacer.style.height = fixNow ? headwrap.offsetHeight + "px" : "0px";
        headwrap.classList.toggle("is-fixed", fixNow);
      }
      headwrap.classList.toggle("is-scrolled", y > headTop + 4);
      if (headwrap.classList.contains("b-headwrap--smart")) {
        if (Math.abs(y - lastY) > 4) {
          headwrap.setAttribute("data-scroll-direction", y > lastY ? "down" : "up");
          lastY = y;
        }
      }
    };
    var tick = false;
    window.addEventListener("scroll", function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () { apply(); tick = false; });
    }, { passive: true });
    window.addEventListener("resize", measure, { passive: true });
    window.addEventListener("load", function () { measure(); apply(); }, { once: true });
    measure(); apply();

    /* header height for the hero slider (it pads itself so the banner starts below the header).
       Only measured while the header is in its resting state, so pinning can't shift the page. */
    var setHeadH = function () {
      if (headwrap.classList.contains("is-fixed")) return;
      document.documentElement.style.setProperty("--b-head-h", headwrap.offsetHeight + "px");
    };
    setHeadH();
    if ("ResizeObserver" in window) new ResizeObserver(setHeadH).observe(headwrap);
    else window.addEventListener("resize", setHeadH, { passive: true });
  }

  /* ---------- desktop menu: hover intent, click mode, keyboard, page dim ---------- */
  document.documentElement.classList.add("b-js");
  $$("[data-b-nav]").forEach(function (nav) {
    var trigger = nav.getAttribute("data-trigger") || "hover";
    var hw = nav.closest("[data-b-header]");
    var scrim = $("[data-b-navscrim]");
    var cur = null, openT = null, closeT = null;
    var linkOf = function (it) { return $(".b-gnav__link", it); };

    function show(it) {
      clearTimeout(openT); clearTimeout(closeT);
      if (cur === it) return;
      if (cur) hide(cur, true);
      fitDrop(it);
      it.classList.add("is-open");
      linkOf(it).setAttribute("aria-expanded", "true");
      cur = it;
      if (hw) hw.classList.add("has-open");
      if (scrim) scrim.classList.toggle("is-on", it.hasAttribute("data-mega"));
    }
    function hide(it, swapping) {
      it = it || cur;
      if (!it) return;
      it.classList.remove("is-open");
      linkOf(it).setAttribute("aria-expanded", "false");
      if (cur === it) cur = null;
      if (!swapping) {
        if (hw) hw.classList.remove("has-open");
        if (scrim) scrim.classList.remove("is-on");
      }
    }
    nav.__bHide = function () { clearTimeout(openT); hide(); };

    /* keep simple dropdowns (and their side flyouts) inside the screen */
    function fitDrop(it) {
      var dp = $(".b-drop", it);
      if (!dp) return;
      var vw = document.documentElement.clientWidth;
      var r = it.getBoundingClientRect(), half = dp.offsetWidth / 2, mid = r.left + r.width / 2, shift = 0;
      if (mid + half > vw - 12) shift = vw - 12 - (mid + half);
      if (mid - half + shift < 12) shift = 12 - (mid - half);
      dp.style.setProperty("--b-shift", Math.round(shift) + "px");
      dp.classList.toggle("is-flip", mid + half + shift + 230 > vw);
    }

    /* responsive menu: tighten spacing first, then fall back to the menu button
       when the items still don't fit (small laptops, iPad landscape, long menus) */
    var list = $(".b-gnav__list", nav);
    function fit() {
      if (!hw || !list) return;
      hw.classList.remove("is-compact", "is-collapsed");
      if (window.innerWidth < 990) return;
      if (list.scrollWidth <= nav.clientWidth + 1) return;
      hw.classList.add("is-compact");
      if (list.scrollWidth <= nav.clientWidth + 1) return;
      hw.classList.add("is-collapsed");
      hide();
    }
    var fitRaf = 0;
    var scheduleFit = function () { cancelAnimationFrame(fitRaf); fitRaf = requestAnimationFrame(fit); };
    window.addEventListener("resize", scheduleFit, { passive: true });
    window.addEventListener("load", scheduleFit, { once: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
    $$("img", hw).forEach(function (img) { if (!img.complete) img.addEventListener("load", scheduleFit, { once: true }); });
    fit();

    $$("[data-b-navitem]", nav).forEach(function (it) {
      var panel = $("[data-b-navpanel]", it);
      if (!panel) return;
      var link = linkOf(it);
      var ptype = "mouse";

      if (trigger === "hover") {
        it.addEventListener("pointerenter", function (e) {
          if (e.pointerType !== "mouse") return;
          clearTimeout(closeT); clearTimeout(openT);
          /* small delay so menus don't flash open while the mouse passes over */
          openT = setTimeout(function () { show(it); }, cur ? 0 : 110);
        });
        it.addEventListener("pointerleave", function (e) {
          if (e.pointerType !== "mouse") return;
          clearTimeout(openT);
          closeT = setTimeout(function () { if (cur === it) hide(it); }, 220);
        });
      }

      link.addEventListener("pointerdown", function (e) { ptype = e.pointerType; });
      link.addEventListener("click", function (e) {
        /* hover mode + mouse: the link simply navigates */
        if (trigger === "hover" && ptype === "mouse" && e.detail > 0) return;
        if (cur === it) {
          /* click mode: second click closes; touch/keyboard in hover mode: second tap navigates */
          if (trigger === "click") { e.preventDefault(); hide(it); }
          return;
        }
        e.preventDefault();
        show(it);
      });
      link.addEventListener("keydown", function (e) {
        if (e.key === "ArrowDown" || (e.key === " " && trigger === "click")) {
          e.preventDefault();
          show(it);
          var first = $("a, button", panel);
          if (first) {
            first.focus();
            if (document.activeElement !== first) requestAnimationFrame(function () { first.focus(); });
          }
        }
      });
      it.addEventListener("focusout", function (e) {
        if (it.contains(e.relatedTarget) || it.matches(":hover")) return;
        if (cur === it) hide(it);
      });
    });

    document.addEventListener("click", function (e) {
      if (cur && !cur.contains(e.target)) hide();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" || !cur) return;
      var l = linkOf(cur);
      hide();
      l.focus();
    });
    window.addEventListener("resize", function () { if (cur && window.innerWidth < 990) hide(); }, { passive: true });
  });

  /* ---------- mega menu tabs: hover (mouse) or tap switches, click on the active tab opens it ---------- */
  function activateTab(tab) {
    var mega = tab.closest(".b-mega");
    var id = tab.getAttribute("data-b-tab");
    $$("[data-b-tab]", mega).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle("is-active", on);
      t.setAttribute("aria-selected", on ? "true" : "false");
    });
    $$("[data-b-tabpanel]", mega).forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-b-tabpanel") === id); });
  }
  var tabT = null;
  document.addEventListener("pointerover", function (e) {
    var tab = e.target.closest && e.target.closest("[data-b-tab]");
    if (!tab || e.pointerType !== "mouse" || tab.classList.contains("is-active")) return;
    clearTimeout(tabT);
    tabT = setTimeout(function () { activateTab(tab); }, 70);
  });
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-b-tab]");
    if (!tab || tab.classList.contains("is-active")) return; /* active tab: follow its link */
    e.preventDefault();
    activateTab(tab);
  });

  /* ---------- mobile menu: smooth accordion, one category open at a time ---------- */
  var reduceMotionNav = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ACC = ".b-mdrawer__group, .b-sheet__group, .b-mdrawer__inner";
  function accBody(d) { return d.querySelector(":scope > summary + *"); }
  function accClose(d) {
    var body = accBody(d);
    if (!d.open || d.classList.contains("is-closing")) return;
    if (reduceMotionNav || !body) { d.open = false; return; }
    d.classList.add("is-closing");
    body.style.height = body.offsetHeight + "px";
    body.classList.add("b-acc-anim");
    void body.offsetHeight;
    body.style.height = "0px";
    body.style.opacity = "0";
    setTimeout(function () {
      d.open = false;
      d.classList.remove("is-closing");
      body.classList.remove("b-acc-anim");
      body.style.height = body.style.opacity = "";
    }, 320);
  }
  function accOpen(d) {
    var body = accBody(d);
    var wrap = d.matches(".b-mdrawer__inner") ? null : d.closest("[data-b-single-open]");
    if (wrap) $$(".b-mdrawer__group[open], .b-sheet__group[open]", wrap).forEach(function (o) { if (o !== d) accClose(o); });
    d.open = true;
    if (reduceMotionNav || !body) return;
    var h = body.scrollHeight;
    body.classList.add("b-acc-anim");
    body.style.height = "0px";
    body.style.opacity = "0";
    void body.offsetHeight;
    body.style.height = h + "px";
    body.style.opacity = "1";
    setTimeout(function () {
      body.classList.remove("b-acc-anim");
      body.style.height = body.style.opacity = "";
      /* bring the opened category into view if it ended up below the fold */
      var sc = d.closest(".b-mdrawer__scroll, .b-sheet__scroll");
      if (!sc || d.matches(".b-mdrawer__inner")) return;
      var top = d.getBoundingClientRect().top - sc.getBoundingClientRect().top;
      if (top < 0 || d.getBoundingClientRect().bottom > sc.getBoundingClientRect().bottom) {
        sc.scrollBy({ top: top - 8, behavior: "smooth" });
      }
    }, 330);
  }
  document.addEventListener("click", function (e) {
    var sum = e.target.closest && e.target.closest("summary");
    if (!sum) return;
    var d = sum.parentElement;
    if (!d || !d.matches(ACC)) return;
    e.preventDefault();
    d.open ? accClose(d) : accOpen(d);
  });

  /* ---------- mobile menu banners: snap slider with dots + gentle autoplay ---------- */
  $$(".b-mdrawer__slides").forEach(function (track) {
    var slides = $$(".b-mdrawer__slide", track);
    if (slides.length < 2) return;
    var dots = document.createElement("div");
    dots.className = "b-mdrawer__dots";
    slides.forEach(function (s, i) {
      var b = document.createElement("button");
      b.type = "button";
      b.setAttribute("aria-label", "Banner " + (i + 1));
      b.addEventListener("click", function () { go(i); });
      dots.appendChild(b);
    });
    track.after(dots);
    var idx = 0, timer = null, touching = false;
    function mark() {
      var w = track.clientWidth || 1;
      idx = Math.round(track.scrollLeft / (slides[0].offsetWidth + 10 || w));
      [].forEach.call(dots.children, function (b, i) { b.classList.toggle("is-active", i === idx); });
    }
    function go(i) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft - parseFloat(getComputedStyle(track).paddingLeft || 0), behavior: "smooth" });
    }
    track.addEventListener("scroll", function () { requestAnimationFrame(mark); }, { passive: true });
    track.addEventListener("touchstart", function () { touching = true; }, { passive: true });
    track.addEventListener("touchend", function () { touching = false; }, { passive: true });
    var panel = track.closest("[data-b-panel]");
    if (panel && "MutationObserver" in window && !reduceMotionNav) {
      new MutationObserver(function () {
        clearInterval(timer);
        if (panel.classList.contains("is-open")) timer = setInterval(function () { if (!touching) go(idx + 1); }, 4500);
      }).observe(panel, { attributes: true, attributeFilter: ["class"] });
    }
    mark();
  });

  /* ---------- swipe a side drawer closed (menu: swipe left · cart: swipe right) ---------- */
  (function () {
    var sw = null;
    document.addEventListener("touchstart", function (e) {
      var dr = e.target.closest && e.target.closest(".b-drawer.is-open");
      if (!dr || e.target.closest(".b-mdrawer__strip, .b-mdrawer__slides, .b-mega__strip, input, textarea, [data-b-drag]")) return;
      var dir = dr.classList.contains("b-drawer--left") ? -1 : 1;
      /* the cart becomes a bottom sheet on small screens unless it's in side mode */
      if (dir === 1 && window.innerWidth <= 767 && !dr.classList.contains("b-cart--mside")) return;
      sw = { dr: dr, dir: dir, x: e.touches[0].clientX, y: e.touches[0].clientY, dx: 0, locked: false };
    }, { passive: true });
    document.addEventListener("touchmove", function (e) {
      if (!sw) return;
      var x = e.touches[0].clientX - sw.x, y = e.touches[0].clientY - sw.y;
      if (!sw.locked) {
        if (Math.abs(x) < 8 && Math.abs(y) < 8) return;
        if (Math.abs(y) > Math.abs(x)) { sw = null; return; } /* vertical scroll wins */
        sw.locked = true;
        sw.dr.classList.add("is-swiping");
      }
      sw.dx = sw.dir < 0 ? Math.min(0, x) : Math.max(0, x);
      sw.dr.style.transform = "translateX(" + sw.dx + "px)";
    }, { passive: true });
    function end() {
      if (!sw) return;
      var s = sw;
      sw = null;
      if (!s.locked) return;
      s.dr.classList.remove("is-swiping");
      if (Math.abs(s.dx) > 70) {
        close();
        requestAnimationFrame(function () { s.dr.style.transform = ""; });
      } else {
        s.dr.style.transform = "";
      }
    }
    document.addEventListener("touchend", end, { passive: true });
    document.addEventListener("touchcancel", end, { passive: true });
  })();

  /* ---------- announcement rotation ---------- */
  $$("[data-b-announce]").forEach(function (bar) {
    var items = $$(".b-announce__item", bar);
    if (items.length < 2) return;
    var i = 0, ms = parseInt(bar.dataset.interval, 10) || 4000;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, ms);
  });

  /* ---------- predictive search (any [data-b-search] wrapper) ---------- */
  $$("[data-b-search]").forEach(function (wrap) {
    var sInput = $("[data-b-search-input]", wrap);
    var sResults = $("[data-b-search-results]", wrap);
    if (!sInput || !sResults) return;
    var t;
    sInput.addEventListener("input", function () {
      clearTimeout(t);
      var q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ""; return; }
      t = setTimeout(function () {
        fetch(rootUrl + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (d.resources && d.resources.results.products) || [];
            sResults.innerHTML = prods.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=92" width="46" height="46" alt="" loading="lazy">' : "";
              return '<a class="b-sresult" href="' + p.url + '">' + img + '<span><span class="b-sresult__t">' + p.title + '</span><br><span class="b-sresult__p">' + p.price + "</span></span></a>";
            }).join("") + (prods.length ? '<a class="b-sresult b-sresult--all" href="' + rootUrl + 'search?q=' + encodeURIComponent(q) + '">See all results →</a>' : "");
          })["catch"](function () {});
      }, 250);
    });
  });

  /* ---------- AJAX cart ---------- */
  var cartQueue = Promise.resolve();
  var lastAdd = null;
  var noteT = null, notePending = null;

  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      var changed = el.textContent.trim() !== String(n);
      el.textContent = n;
      el.classList.toggle("is-empty", n === 0);
      if (changed) { el.classList.remove("b-pop"); void el.offsetWidth; el.classList.add("b-pop"); }
    });
  }

  var toastT;
  function toast(msg) {
    var t = $(".b-toast");
    if (!t) {
      t = document.createElement("div");
      t.className = "b-toast";
      t.setAttribute("role", "alert");
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.remove("is-on");
    void t.offsetWidth;
    t.classList.add("is-on");
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove("is-on"); }, 3800);
  }

  var CartAPI = {
    root: function () { return $("[data-b-cart]"); },
    sid: function () { var c = this.root(); return c ? c.dataset.sectionId : null; },
    busy: function (on) { var c = this.root(); if (c) c.classList.toggle("is-loading", on); },
    error: function (msg) { toast(msg || "Something went wrong. Please try again."); },

    /* swap the drawer contents but keep scroll position, open note, unsaved note text, focus,
       and animate the rewards bar from its old width */
    render: function (html) {
      var c = this.root();
      if (!c || !html) return;
      var tmp = document.createElement("div");
      tmp.innerHTML = html;
      var fresh = $("[data-b-cart-inner]", tmp);
      var cur = $("[data-b-cart-inner]", c);
      if (!fresh || !cur) return;

      var list = $(".b-cart__items", cur), scroll = list ? list.scrollTop : 0;
      var note = $(".b-note", cur), noteOpen = !!(note && note.open);
      var bar = $(".b-progress span", cur), oldW = bar ? bar.style.width : null;
      var ae = document.activeElement, focusSel = null;
      if (ae && cur.contains(ae)) {
        var card = ae.closest("[data-key]");
        if (card && ae.matches("[data-b-qty]")) focusSel = '[data-key="' + card.dataset.key + '"] [data-b-qty="' + ae.getAttribute("data-b-qty") + '"]';
        else if (ae.matches("[data-b-note]")) focusSel = "[data-b-note]";
      }

      cur.replaceWith(fresh);

      var nl = $(".b-cart__items", fresh);
      if (nl) nl.scrollTop = scroll;
      var nn = $(".b-note", fresh);
      if (nn && noteOpen) nn.open = true;
      var nf = $("[data-b-note]", fresh);
      if (nf && notePending !== null) nf.value = notePending;
      var nb = $(".b-progress span", fresh);
      if (nb && oldW && oldW !== nb.style.width) {
        var w = nb.style.width;
        nb.style.width = oldW;
        void nb.offsetWidth;
        nb.style.width = w;
      }
      if (focusSel) {
        var f = $(focusSel, fresh) || $("[data-b-close]", fresh);
        if (f) f.focus({ preventScroll: true });
      } else if (ae && !document.contains(ae) && openPanel === c) {
        c.focus({ preventScroll: true });
      }
      var chip = $("[data-cart-count-label]", fresh);
      if (chip) setCount(parseInt(chip.getAttribute("data-count") || chip.textContent, 10) || 0);
      document.dispatchEvent(new CustomEvent("beme:cart:rendered"));
    },

    refresh: function (thenOpen) {
      var sid = this.sid();
      if (!sid) return Promise.resolve();
      return fetch(window.location.pathname + "?sections=" + encodeURIComponent(sid), { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (json) { CartAPI.render(json[sid]); })
        ["catch"](function () {})
        .then(function () { CartAPI.busy(false); if (thenOpen) open("cart"); });
    },

    /* every cart request goes through one queue, so fast taps can't race each other.
       The drawer HTML comes back in the same response (Section Rendering API). */
    post: function (path, data) {
      if (path === "cart/add.js") {
        var sig = data instanceof FormData ? JSON.stringify([].slice.call(data.entries()).filter(function (kv) { return typeof kv[1] === "string"; })) : JSON.stringify(data);
        var now = Date.now();
        if (lastAdd && lastAdd.sig === sig && now - lastAdd.t < 1500) return lastAdd.p;
        var p = this._post(path, data);
        lastAdd = { sig: sig, t: now, p: p };
        return p;
      }
      return this._post(path, data);
    },

    _post: function (path, data) {
      var sid = this.sid();
      var headers = { Accept: "application/json" };
      var body;
      if (data instanceof FormData) {
        body = data;
        if (sid) { body.append("sections", sid); body.append("sections_url", window.location.pathname); }
      } else {
        data = Object.assign({}, data || {});
        if (sid) { data.sections = sid; data.sections_url = window.location.pathname; }
        body = JSON.stringify(data);
        headers["Content-Type"] = "application/json";
      }
      var run = function () {
        return fetch(rootUrl + path, { method: "POST", headers: headers, body: body })
          .then(function (r) {
            return r.json()["catch"](function () { return {}; }).then(function (j) {
              if (!r.ok || j.status) {
                var err = new Error(j.description || j.message || "Something went wrong. Please try again.");
                err.data = j;
                throw err;
              }
              return j;
            });
          })
          .then(function (j) {
            if (sid && j.sections && j.sections[sid]) { CartAPI.render(j.sections[sid]); CartAPI.busy(false); return j; }
            return CartAPI.refresh().then(function () { return j; });
          }, function (err) {
            /* resync with the real cart, then report */
            return CartAPI.refresh().then(function () { CartAPI.error(err.message); throw err; });
          });
      };
      var p = cartQueue.then(run, run);
      cartQueue = p["catch"](function () {});
      return p;
    },

    change: function (ref, qty) {
      return this.post("cart/change.js", typeof ref === "string" ? { id: ref, quantity: qty } : { line: ref, quantity: qty });
    },

    add: function (variantId, qty) {
      this.busy(true);
      return this.post("cart/add.js", { items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
        .then(function (j) { open("cart"); return j; });
    }
  };
  window.BemeCart = CartAPI; /* public API: BemeCart.add(variantId), BemeCart.refresh(true) */

  /* ---------- fly-to-cart animation ---------- */
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function flyToCart(sourceBtn) {
    if (reduceMotion || !sourceBtn) return Promise.resolve();
    var scope = sourceBtn.closest(".b-pcard, .lx-card, .b-upsell__row, form, section, main") || document;
    var img = scope.querySelector("img");
    var cartBtn = null;
    $$('[data-b-open="cart"]').forEach(function (b) { if (b.offsetParent) cartBtn = cartBtn || b; });
    if (!img || !cartBtn || !img.src) return Promise.resolve();
    var a = img.getBoundingClientRect(), b = cartBtn.getBoundingClientRect();
    if (!a.width || !b.width) return Promise.resolve();
    var size = Math.min(a.width, a.height, 92);
    var clone = document.createElement("img");
    clone.src = img.currentSrc || img.src;
    clone.className = "b-fly";
    clone.style.cssText = "left:" + (a.left + a.width / 2 - size / 2) + "px;top:" + (a.top + a.height / 2 - size / 2) + "px;width:" + size + "px;height:" + size + "px;";
    document.body.appendChild(clone);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    if (!clone.animate) { clone.remove(); return Promise.resolve(); }
    var anim = clone.animate([
      { transform: "translate(0,0) scale(1)", opacity: 1 },
      { transform: "translate(" + dx * 0.5 + "px," + (dy * 0.5 - 70) + "px) scale(.6)", opacity: .95, offset: .55 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(.12)", opacity: .4 }
    ], { duration: 620, easing: "cubic-bezier(.3,.75,.45,1)" });
    return anim.finished["catch"](function () {}).then(function () { clone.remove(); });
  }
  window.BemePanel = { open: open, close: close };

  /* ---------- line items: quantity, remove ---------- */
  var qtyTimers = {};
  function lineRef(line) { return line.dataset.key || parseInt(line.dataset.line, 10); }
  /* lines on the cart page (outside the drawer) need the page re-rendered afterwards.
     Checked before the request: the drawer re-render detaches the old line element. */
  function outsideDrawer(line) {
    var c = CartAPI.root();
    return !c || !c.contains(line);
  }
  function setQty(line, q) {
    var ref = lineRef(line), k = String(ref), reload = outsideDrawer(line);
    clearTimeout(qtyTimers[k]);
    line.classList.add("is-updating");
    qtyTimers[k] = setTimeout(function () {
      delete qtyTimers[k];
      CartAPI.change(ref, q).then(function () { if (reload) window.location.reload(); }, function () { line.classList.remove("is-updating"); });
    }, 350);
  }
  function removeLine(line) {
    var ref = lineRef(line), reload = outsideDrawer(line);
    clearTimeout(qtyTimers[String(ref)]);
    line.classList.add("is-removing");
    CartAPI.change(ref, 0).then(function () { if (reload) window.location.reload(); }, function () { line.classList.remove("is-removing"); });
  }

  document.addEventListener("click", function (e) {
    var line = e.target.closest(".b-card[data-line], .b-line");
    var qbtn = e.target.closest("[data-b-qty]");
    if (qbtn && line) {
      e.preventDefault();
      var input = $("[data-b-qty-input]", line);
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qbtn.getAttribute("data-b-qty"), 10));
      input.value = q; /* optimistic — UI updates instantly, request is debounced */
      q === 0 ? removeLine(line) : setQty(line, q);
      return;
    }
    if (e.target.closest("[data-b-remove]") && line) {
      e.preventDefault();
      removeLine(line);
      return;
    }
    var add = e.target.closest("[data-b-add]");
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      add.classList.add("is-adding");
      var fly = flyToCart(add);
      var req = CartAPI.post("cart/add.js", { items: [{ id: parseInt(add.getAttribute("data-b-add"), 10), quantity: parseInt(add.getAttribute("data-qty"), 10) || 1 }] });
      Promise.all([fly, req])
        .then(function () { open("cart"); }, function () {})
        .then(function () { add.disabled = false; add.classList.remove("is-adding"); });
    }
  });

  document.addEventListener("change", function (e) {
    if (!e.target.matches("[data-b-qty-input]")) return;
    var line = e.target.closest(".b-card[data-line], .b-line");
    if (!line) return;
    var q = Math.max(0, parseInt(e.target.value, 10) || 0);
    e.target.value = q;
    q === 0 ? removeLine(line) : setQty(line, q);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && e.target.matches && e.target.matches("[data-b-qty-input]")) { e.preventDefault(); e.target.blur(); }
  });

  /* ---------- LX product-card quick add -> this drawer (instead of jumping to /cart) ---------- */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-lx-add]");
    if (!btn || !CartAPI.root()) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute("data-lx-state") === "loading") return;
    btn.setAttribute("data-lx-state", "loading");
    var fly = flyToCart(btn);
    var req = CartAPI.post("cart/add.js", { items: [{ id: parseInt(btn.getAttribute("data-lx-add"), 10), quantity: parseInt(btn.getAttribute("data-qty"), 10) || 1 }] });
    Promise.all([fly, req]).then(function () {
      btn.setAttribute("data-lx-state", "done");
      open("cart");
      setTimeout(function () { btn.removeAttribute("data-lx-state"); }, 1600);
    }, function () { btn.removeAttribute("data-lx-state"); });
  }, true);

  /* ---------- Horizon bridge ----------
     Horizon buy buttons add to cart via internal fetch + custom events; sync our drawer.
     Also set --header-height vars Horizon's layout script expects. */
  var hzT;
  ["cart:update", "cart:change", "cart:refresh", "cart:added", "on:cart:add", "variant:add"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.detail && e.detail.source === "beme") return;
      clearTimeout(hzT);
      var onCartPage = /\/cart\/?$/.test(window.location.pathname);
      hzT = setTimeout(function () { CartAPI.refresh(!onCartPage); }, 60);
    });
  });
  function setHeaderVars() {
    if (!headwrap || headwrap.classList.contains("is-fixed")) return;
    var a = $("[data-b-announce]");
    document.body.style.setProperty("--header-height", headwrap.offsetHeight + "px");
    document.body.style.setProperty("--header-group-height", (headwrap.offsetHeight + (a ? a.offsetHeight : 0)) + "px");
  }
  setHeaderVars();
  window.addEventListener("resize", setHeaderVars, { passive: true });

  /* ---------- card color swatches: swap card image ---------- */
  document.addEventListener("click", function (e) {
    var sw = e.target.closest("[data-b-swatch]");
    if (!sw || !sw.dataset.img) return;
    e.preventDefault();
    var card = sw.closest(".b-pcard");
    var img = card && card.querySelector("[data-b-cardimg]");
    if (!img) return;
    img.src = sw.dataset.img;
    if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
    var act = card.querySelector(".b-swatch.is-active");
    if (act) act.classList.remove("is-active");
    sw.classList.add("is-active");
  });

  /* ---------- order note (debounced save) + clear cart + checkout ---------- */
  function saveNote(v) {
    return fetch(rootUrl + "cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ note: v }),
      keepalive: true
    })["catch"](function () {});
  }
  document.addEventListener("input", function (e) {
    if (!e.target.matches("[data-b-note]")) return;
    clearTimeout(noteT);
    notePending = e.target.value;
    noteT = setTimeout(function () {
      var v = notePending;
      noteT = null;
      notePending = null;
      saveNote(v);
    }, 500);
  });
  document.addEventListener("click", function (e) {
    var co = e.target.closest("[data-b-checkout]");
    if (co) {
      if (co.classList.contains("is-going")) { e.preventDefault(); return; }
      co.classList.add("is-going");
      /* make sure a note typed a moment ago is saved before leaving */
      if (notePending !== null) {
        e.preventDefault();
        clearTimeout(noteT);
        var v = notePending;
        noteT = null;
        notePending = null;
        saveNote(v).then(function () { window.location.href = co.href; });
      }
      setTimeout(function () { co.classList.remove("is-going"); }, 4000);
      return;
    }
    if (!e.target.closest("[data-b-clear]")) return;
    if (!window.confirm("Remove all items from your cart?")) return;
    CartAPI.busy(true);
    CartAPI.post("cart/clear.js", {})["catch"](function () {});
  });

  /* warm the cart section on first hover/touch of any cart button (fast first open) */
  var warmed = false;
  ["mouseenter", "touchstart"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (warmed || !e.target.closest || !e.target.closest('[data-b-open="cart"]')) return;
      warmed = true;
      var c = CartAPI.root();
      if (c) fetch(window.location.pathname + "?sections=" + c.dataset.sectionId).catch(function(){});
    }, { passive: true, capture: true });
  });

  /* ---------- hero slider: autoplay, dots, arrows, JIT warm ---------- */
  $$("[data-b-hero]").forEach(function (hero) {
    var track = $("[data-b-hero-track]", hero);
    if (!track) return;
    var slides = $$(".b-hero__slide", track);
    if (slides.length < 2) return;
    var dots = $$("[data-b-hero-dot]", hero);
    var idx = 0, timer = null, speed = parseInt(hero.dataset.speed, 10) || 5000;

    function go(i, instant) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: instant ? "auto" : "smooth" });
    }
    /* observe which slide is visible -> sync dots + warm the NEXT slide's image */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.intersectionRatio < 0.55) return;
        idx = slides.indexOf(en.target);
        dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
        var next = slides[(idx + 1) % slides.length];
        var img = next && next.querySelector("img[loading=lazy]");
        if (img) img.loading = "eager";
      });
    }, { root: track, threshold: 0.55 });
    slides.forEach(function (s) { io.observe(s); });

    dots.forEach(function (d) {
      d.addEventListener("click", function () { go(parseInt(d.dataset.bHeroDot, 10)); restart(); });
    });
    var prev = $("[data-b-hero-prev]", hero), next = $("[data-b-hero-next]", hero);
    if (prev) prev.addEventListener("click", function () { go(idx - 1); restart(); });
    if (next) next.addEventListener("click", function () { go(idx + 1); restart(); });

    var auto = hero.dataset.autoplay === "true" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function start() { if (auto && !timer) timer = setInterval(function () { go(idx + 1); }, speed); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }
    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", start);
    hero.addEventListener("touchstart", stop, { passive: true });
    hero.addEventListener("touchend", function () { setTimeout(start, 3000); }, { passive: true });
    document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });
    start();
  });

  /* ---------- collection: AJAX filters, sort, pagination ---------- */
  var colRoot = $("[data-b-col]");
  if (colRoot) {
    var colForm = $("[data-b-filter]", colRoot);
    var colBusy = false;

    function colFetch(url, scroll) {
      if (colBusy) return;
      colBusy = true;
      colRoot.classList.add("is-loading");
      var sid = colRoot.dataset.sectionId;
      var u = new URL(url, window.location.origin);
      u.searchParams.set("section_id", sid);
      fetch(u.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = tmp.querySelector("[data-b-col]");
          if (fresh) {
            colRoot.innerHTML = fresh.innerHTML;
            colForm = $("[data-b-filter]", colRoot);
          }
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete("section_id");
          history.pushState({}, "", clean.toString());
          if (scroll) colRoot.scrollIntoView({ behavior: "smooth", block: "start" });
        })
        ["finally"](function () {
          colBusy = false;
          colRoot.classList.remove("is-loading");
        });
    }

    function colSubmit() {
      if (!colForm) return;
      var fd = new FormData(colForm);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== "") params.append(k, v); });
      colFetch(colForm.getAttribute("action") + "?" + params.toString(), false);
    }

    var priceT;
    document.addEventListener("change", function (e) {
      if (!colRoot.contains(e.target)) return;
      if (e.target.matches("[data-b-sort]")) { colSubmit(); return; }
      if (e.target.matches("[data-b-price]")) { clearTimeout(priceT); priceT = setTimeout(colSubmit, 600); return; }
      if (e.target.matches('.b-filters input[type="checkbox"]')) {
        /* live-apply on desktop; on mobile wait for "Show results" */
        if (window.matchMedia("(min-width: 990px)").matches) colSubmit();
      }
    });

    document.addEventListener("click", function (e) {
      if (!colRoot.contains(e.target)) return;
      var link = e.target.closest("[data-b-filter-link], [data-b-page]");
      if (link) {
        e.preventDefault();
        colFetch(link.getAttribute("href"), link.hasAttribute("data-b-page"));
      }
    });

    document.addEventListener("submit", function (e) {
      if (e.target === colForm) { e.preventDefault(); colSubmit(); close(); }
    });

    window.addEventListener("popstate", function () {
      colFetch(window.location.href, false);
    });
  }

  /* ---------- product page: variants, gallery, buy now, sticky bar ---------- */
  var pp = $("[data-b-product]");
  if (pp) {
    var vdataEl = $("[data-b-variants]", pp);
    var variants = vdataEl ? JSON.parse(vdataEl.textContent) : [];
    var moneyFmt = ($("[data-b-money]", pp) ? JSON.parse($("[data-b-money]", pp).textContent) : "Rs.{{amount}}");
    function money(cents) {
      var n = (cents / 100).toFixed(2).replace(/\.00$/, "");
      n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, n).replace(/0([.,]00)?$/, function (m) { return m === "0" ? n : m; });
    }
    /* simpler: derive prefix/suffix from formatted zero */
    var zeroParts = moneyFmt.split(/0(?:[.,]00)?/);
    function fmt(cents) {
      var n = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return (zeroParts[0] || "") + n + (zeroParts[1] || "");
    }

    function selectedOptions() {
      return $$("[data-b-opt]", pp).map(function (f) {
        var ch = $("input:checked, select", f);
        return ch ? ch.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function showMedia(id) {
      if (!id) return;
      $$("[data-b-frame]", pp).forEach(function (f) { f.classList.toggle("is-active", f.dataset.bFrame == id); });
      $$("[data-b-thumb]", pp).forEach(function (t) {
        var on = t.dataset.bThumb == id;
        t.classList.toggle("is-active", on);
        if (on) t.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
      });
    }
    function applyVariant(v) {
      if (!v) return;
      var idInput = $("[data-b-variant-id]", pp);
      if (idInput) idInput.value = v.id;
      var now = $("[data-b-price-now]", pp), was = $("[data-b-price-was]", pp), save = $("[data-b-price-save]", pp);
      if (now) now.textContent = fmt(v.price);
      var onSale = v.cap > v.price;
      if (was) { was.hidden = !onSale; if (onSale) was.textContent = fmt(v.cap); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = "You save " + fmt(v.cap - v.price); }
      var badge = $("[data-b-pp-badge]", pp);
      if (badge) {
        if (onSale) { badge.hidden = false; badge.textContent = "-" + Math.round((v.cap - v.price) * 100 / v.cap) + "%"; }
        else badge.hidden = true;
      }
      var atc = $("[data-b-pp-atc]", pp), lbl = $("[data-b-atc-label]", pp);
      if (atc) atc.disabled = !v.available;
      if (lbl) lbl.textContent = v.available ? (atc.dataset.label || lbl.dataset.a || lbl.textContent.replace("Sold Out", "Add to Cart")) : "Sold Out";
      var barP = $("[data-b-bar-price]", pp), barA = $("[data-b-bar-atc]", pp);
      if (barP) barP.textContent = fmt(v.price);
      if (barA) barA.disabled = !v.available;
      $$("[data-b-opt]", pp).forEach(function (f) {
        var out = $("[data-b-opt-value]", f), ch = $("input:checked, select", f);
        if (out && ch) out.textContent = ch.value;
      });
      showMedia(v.media);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      } catch (err) {}
    }

    pp.addEventListener("change", function (e) {
      if (e.target.matches("[data-b-opt-input]")) applyVariant(findVariant(selectedOptions()));
    });
    /* addons: reveal personalization field; letters-only live validation */
    pp.addEventListener("change", function (e) {
      var chk = e.target.closest("[data-b-addon-check]");
      if (chk) {
        var root = chk.closest("[data-b-addon]");
        var field = $("[data-b-addon-field]", root);
        if (field) field.hidden = !chk.checked;
        var vars = $("[data-b-addon-variants]", root);
        if (vars) vars.hidden = !chk.checked;
      }
      var vr = e.target.closest("[data-b-addon-vradio]");
      if (vr) {
        var root2 = vr.closest("[data-b-addon]");
        var chk2 = $("[data-b-addon-check]", root2);
        if (chk2) chk2.dataset.variant = vr.value;
        var name = $("[data-b-addon-vname]", root2);
        var img = vr.nextElementSibling;
        if (name && img) name.textContent = img.alt || img.textContent || "";
      }
    });
    /* anchor tabs: smooth scroll */
    pp.addEventListener("click", function (e) {
      var a = e.target.closest("[data-b-anchor]");
      if (!a) return;
      var t = document.querySelector(a.getAttribute("href"));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
    pp.addEventListener("input", function (e) {
      if (e.target.matches("[data-b-addon-text]")) {
        e.target.value = e.target.value.replace(/[^A-Za-z ]/g, "");
      }
    });
    function ppItems() {
      var form = $("[data-b-pp-form]", pp);
      var qty = parseInt(($('input[name="quantity"]', form) || {}).value, 10) || 1;
      var items = [{ id: parseInt($("[data-b-variant-id]", form).value, 10), quantity: qty }];
      $$("[data-b-addon]", pp).forEach(function (a) {
        var chk = $("[data-b-addon-check]", a);
        if (!chk || !chk.checked) return;
        var item = { id: parseInt(chk.dataset.variant, 10), quantity: 1 };
        var txt = $("[data-b-addon-text]", a);
        if (txt && txt.value.trim()) {
          var props = {};
          props[txt.dataset.prop || "Personalization"] = txt.value.trim();
          item.properties = props;
        }
        items.push(item);
      });
      return items;
    }
    function ppAdd() {
      return CartAPI.post("cart/add.js", { items: ppItems() });
    }
    /* own submit handler (capture) so addons ride along as extra line items */
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (!pp.contains(f) || !f.matches("[data-b-pp-form]")) return;
      e.preventDefault();
      e.stopPropagation();
      var btn = $("[data-b-pp-atc]", pp);
      var lbl = $("[data-b-atc-label]", pp);
      var orig = lbl ? lbl.textContent : "";
      if (btn) { btn.disabled = true; btn.classList.add("is-adding"); }
      var fly = (typeof flyToCart === "function") ? flyToCart(btn) : Promise.resolve();
      var req = ppAdd();
      Promise.all([fly, req]).then(function () {
        if (btn) {
          btn.classList.remove("is-adding");
          btn.classList.add("is-added");
          if (lbl) lbl.textContent = "✓ Added";
          setTimeout(function () {
            btn.classList.remove("is-added");
            if (lbl) lbl.textContent = orig;
            btn.disabled = false;
          }, 1400);
        }
        open("cart");
      }, function () {
        if (btn) { btn.classList.remove("is-adding"); btn.disabled = false; }
      });
    }, true);

    pp.addEventListener("click", function (e) {
      var th = e.target.closest("[data-b-thumb]");
      if (th) showMedia(th.dataset.bThumb);
      var pq = e.target.closest("[data-b-pq]");
      if (pq) {
        var inp = $('input[name="quantity"]', pp);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(pq.dataset.bPq, 10));
      }
      var bn = e.target.closest("[data-b-buynow]");
      if (bn) {
        bn.disabled = true;
        bn.classList.add("is-adding");
        ppAdd()
          .then(function () { window.location.href = rootUrl + "checkout"; })
          ["catch"](function () { bn.disabled = false; bn.classList.remove("is-adding"); });
      }
      var ba = e.target.closest("[data-b-bar-atc]");
      if (ba) {
        var f2 = $("[data-b-pp-form]", pp);
        if (f2) f2.requestSubmit ? f2.requestSubmit() : f2.submit();
      }
    });

    /* sticky bar visibility */
    var bar = $("[data-b-ppbar]", pp);
    var mainAtc = $("[data-b-pp-atc]", pp);
    if (bar && mainAtc && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle("is-show", !en[0].isIntersecting && window.scrollY > 300);
      }, { threshold: 0 }).observe(mainAtc);
    }
  }

  /* ---------- product description read-more ---------- */
  document.addEventListener("click", function (e) {
    var m = e.target.closest("[data-beme-pd-more]");
    if (!m) return;
    var body = $("[data-beme-pd]");
    if (!body) return;
    var open = body.classList.toggle("is-open");
    m.textContent = open ? "Read less" : "Read more";
  });

  /* ---------- footer: back-to-top + mobile accordions ---------- */
  var topBtn = $("[data-b-top]");
  if (topBtn) {
    topBtn.hidden = false;
    var tT = false;
    window.addEventListener("scroll", function () {
      if (tT) return;
      tT = true;
      requestAnimationFrame(function () {
        topBtn.classList.toggle("is-show", window.scrollY > 500);
        tT = false;
      });
    }, { passive: true });
    topBtn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
  if (window.matchMedia("(max-width: 767px)").matches) {
    $$("details.b-foot__col[open]").forEach(function (d) { d.removeAttribute("open"); });
  }

  /* Intercept standard product forms so adds open our drawer.
     Add data-b-native to any form to keep default behavior.
     Forms already handled by another script (Horizon's product form) are left alone —
     Horizon then fires cart:update and the bridge above opens this drawer. */
  window.addEventListener("submit", function (e) {
    var f = e.target;
    if (e.defaultPrevented || !CartAPI.root()) return;
    if (!f.matches('form[action*="/cart/add"]:not([data-b-native])') || f.closest("product-form-component")) return;
    e.preventDefault();
    var btn = e.submitter || $('[type="submit"]', f);
    if (btn) btn.disabled = true;
    var fly = flyToCart(btn || f);
    var req = CartAPI.post("cart/add.js", new FormData(f));
    Promise.all([fly, req])
      .then(function () { open("cart"); }, function () {})
      .then(function () { if (btn) btn.disabled = false; });
  });
})();
/*!
 * LX Premium kit – one file for: hero slider, pill header + mega menu + mobile drawer,
 * animated footer, product cards (quick add), carousels, tabs, scroll reveal.
 * Load once in layout/theme.liquid with: <script src="{{ 'lx-premium.js' | asset_url }}" defer></script>
 */
(function () {
  'use strict';
  if (window.__lxPremium) return;
  window.__lxPremium = true;

  var lx = (window.lx = window.lx || {});
  var settings = window.lxSettings || {};
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* =========================================================== money + toast */
  lx.money = function (cents) {
    var format = settings.moneyFormat || 'Rs.{{amount_no_decimals}}';
    cents = Number(String(cents).replace('.', '')) || 0;
    function fmt(n, d, t, dec) {
      var parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t) + (parts[1] ? dec + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
      if (key === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
      return fmt(cents, 2, ',', '.');
    });
  };

  var toastEl, toastTimer;
  lx.toast = function (message, type) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.className = 'lx-toast' + (type ? ' lx-toast--' + type : '');
    toastEl.textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  };

  /* =========================================================== cart (quick add) */
  function rootUrl() {
    var r = settings.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  lx.cart = {
    add: function (items) {
      var actions = window.Shopify && window.Shopify.actions;
      if (actions && actions.updateCart) {
        // Horizon: updates the cart drawer + cart count automatically
        return actions
          .updateCart(
            { lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: Number(i.quantity) || 1 }; }) },
            { event: { context: 'product' } }
          )
          .then(function (res) {
            if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
            var drawer = document.querySelector('theme-drawer#cart-drawer');
            if (!drawer || !drawer.hasAttribute('open')) actions.openCart && actions.openCart();
            return res;
          });
      }
      return fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items.map(function (i) { return { id: Number(i.id), quantity: Number(i.quantity) || 1 }; }) })
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) throw new Error(json.description || json.message || 'Could not add to cart');
          window.location.href = settings.cartUrl || rootUrl() + 'cart';
          return json;
        });
    }
  };

  function withState(btn, promiseFn) {
    if (!btn || btn.getAttribute('data-lx-state') === 'loading') return;
    btn.setAttribute('data-lx-state', 'loading');
    btn.setAttribute('aria-busy', 'true');
    Promise.resolve()
      .then(promiseFn)
      .then(function () {
        btn.setAttribute('data-lx-state', 'done');
        setTimeout(function () { btn.removeAttribute('data-lx-state'); }, 1600);
      })
      .catch(function (e) {
        btn.removeAttribute('data-lx-state');
        lx.toast((e && e.message) || 'Something went wrong', 'error');
      })
      .then(function () { btn.removeAttribute('aria-busy'); });
  }
  lx.withState = withState;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-lx-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    withState(btn, function () {
      return lx.cart.add([{ id: btn.getAttribute('data-lx-add'), quantity: Number(btn.getAttribute('data-qty')) || 1 }]);
    });
  });

  /* =========================================================== scroll reveal */
  var motion = !designMode && !reduceMotion && 'IntersectionObserver' in window;
  var revealObserver = null;
  lx.reveal = function (scope) {
    var items = Array.prototype.slice.call((scope || document).querySelectorAll('[data-lx-reveal]:not(.is-in)'));
    if (!items.length) return;
    if (!motion) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var vh = window.innerHeight;
    items.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add('is-in');
    });
    // Content is only hidden once this script is running, so a broken script never hides the page
    root.classList.add('lx-anim');
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    }
    items.forEach(function (el) {
      if (el.classList.contains('is-in')) return;
      if (el.parentElement && !el.style.getPropertyValue('--lx-i')) {
        var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.hasAttribute('data-lx-reveal'); });
        if (sibs.length > 1) el.style.setProperty('--lx-i', String(Math.min(sibs.indexOf(el), 6)));
      }
      revealObserver.observe(el);
    });
  };

  /* =========================================================== carousels */
  lx.carousels = function (scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lx-carousel]:not([data-lx-bound])'), function (wrap) {
      wrap.setAttribute('data-lx-bound', '');
      var tracks = Array.prototype.slice.call(wrap.querySelectorAll('[data-lx-track]'));
      var prev = wrap.querySelector('[data-lx-prev]');
      var next = wrap.querySelector('[data-lx-next]');
      if (!tracks.length) return;
      function track() {
        for (var i = 0; i < tracks.length; i++) if (tracks[i].offsetParent !== null) return tracks[i];
        return tracks[0];
      }
      function step() {
        var t = track();
        var first = t.firstElementChild;
        if (!first) return t.clientWidth;
        var gap = parseFloat(getComputedStyle(t).columnGap) || 0;
        var w = first.getBoundingClientRect().width + gap;
        return w * Math.max(1, Math.floor((t.clientWidth + gap) / w));
      }
      function update() {
        var t = track();
        if (prev) prev.disabled = t.scrollLeft <= 2;
        if (next) next.disabled = t.scrollLeft >= t.scrollWidth - t.clientWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { track().scrollBy({ left: -step() }); });
      if (next) next.addEventListener('click', function () { track().scrollBy({ left: step() }); });
      tracks.forEach(function (t) { t.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true }); });
      wrap.addEventListener('lx:tab', function () { requestAnimationFrame(update); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { update(); }).observe(tracks[0]);
      window.addEventListener('load', update, { once: true });
      update();
    });
  };

  /* =========================================================== tabs */
  lx.tabs = function (scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-lx-tabs]:not([data-lx-bound])'), function (wrap) {
      wrap.setAttribute('data-lx-bound', '');
      var buttons = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      function select(i, focus) {
        buttons.forEach(function (b, j) { b.setAttribute('aria-selected', String(i === j)); b.tabIndex = i === j ? 0 : -1; });
        panels.forEach(function (p, j) { p.hidden = i !== j; if (i === j) lx.reveal(p); });
        if (focus) buttons[i].focus();
        wrap.dispatchEvent(new CustomEvent('lx:tab', { bubbles: true }));
      }
      buttons.forEach(function (b, i) {
        b.addEventListener('click', function () { select(i); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') select((i + 1) % buttons.length, true);
          if (e.key === 'ArrowLeft') select((i - 1 + buttons.length) % buttons.length, true);
        });
      });
    });
  };

  /* =========================================================== hero slider */
  function initSlider(el) {
    if (!el || el.getAttribute('data-bound')) return;
    el.setAttribute('data-bound', '1');
    var track = el.querySelector('.ghs__track');
    var slides = Array.prototype.slice.call(el.querySelectorAll('.ghs__slide'));
    var dots = Array.prototype.slice.call(el.querySelectorAll('.ghs__dot'));
    var n = slides.length;
    if (n < 2 || !track) return;

    var cur = 0, timer = null, busy = false, ready = false, inView = false, hovering = false, editorHold = false;
    var autoplay = el.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 5000;

    function wait(p, ms) { return Promise.race([p, new Promise(function (r) { setTimeout(r, ms); })]); }
    // Images of slides 2+ only load when needed (and only the desktop OR mobile version)
    function hydrate(s) {
      if (!s || s.getAttribute('data-loaded')) return Promise.resolve();
      s.setAttribute('data-loaded', '1');
      Array.prototype.forEach.call(s.querySelectorAll('source[data-srcset]'), function (src) {
        src.srcset = src.getAttribute('data-srcset');
        src.removeAttribute('data-srcset');
      });
      var img = s.querySelector('img');
      if (!img) return Promise.resolve();
      if (img.getAttribute('data-src')) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
      return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    }
    function canPlay() {
      return autoplay && ready && inView && !hovering && !editorHold && document.visibilityState === 'visible';
    }
    function restartProgress() {
      var dot = dots[cur];
      if (!dot) return;
      dot.classList.remove('is-active');
      void dot.offsetWidth;
      dot.classList.add('is-active');
    }
    function schedule() {
      clearTimeout(timer);
      if (canPlay()) {
        el.setAttribute('data-playing', '1');
        restartProgress();
        timer = setTimeout(function () { go(cur + 1); }, speed);
      } else {
        el.setAttribute('data-playing', '0');
      }
    }
    function go(i) {
      i = (i + n) % n;
      if (i === cur || busy) return;
      busy = true;
      clearTimeout(timer);
      var prev = slides[cur], next = slides[i];
      wait(hydrate(next), 4000).then(function () {
        prev.classList.remove('is-active'); prev.setAttribute('aria-hidden', 'true');
        next.classList.add('is-active'); next.removeAttribute('aria-hidden');
        var pl = prev.querySelector('.ghs__link'), nl = next.querySelector('.ghs__link');
        if (pl) pl.tabIndex = -1;
        if (nl) nl.removeAttribute('tabindex');
        if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].removeAttribute('aria-current'); }
        if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
        if (next.getAttribute('data-gradient')) el.style.setProperty('--ghs-g1', next.getAttribute('data-gradient'));
        cur = i;
        busy = false;
        if (ready) hydrate(slides[(i + 1) % n]);
        schedule();
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-index'), 10)); });
    });
    var sx = 0, sy = 0, swiped = false;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; go(cur + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    track.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);
    if (el.getAttribute('data-hover') === 'true') {
      track.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; schedule(); } });
      track.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovering = false; schedule(); } });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(track);
    } else { inView = true; }
    document.addEventListener('visibilitychange', schedule);
    // Autoplay starts only after the whole page has loaded
    function start() { ready = true; hydrate(slides[1]); schedule(); }
    function onLoaded() {
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
      else setTimeout(start, 300);
    }
    if (document.readyState === 'complete') onLoaded();
    else window.addEventListener('load', onLoaded, { once: true });
    el.__lxGo = function (idx) { editorHold = true; go(idx); };
    el.__lxRelease = function () { editorHold = false; schedule(); };
    el.__lxSlides = slides;
  }
  lx.sliders = function (scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.ghs'), initSlider);
  };
  document.addEventListener('shopify:block:select', function (e) {
    var slider = e.target.closest && e.target.closest('.ghs');
    if (slider && slider.__lxGo) slider.__lxGo(slider.__lxSlides.indexOf(e.target));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var slider = e.target.closest && e.target.closest('.ghs');
    if (slider && slider.__lxRelease) slider.__lxRelease();
  });

  /* =========================================================== header */
  function initHeader(hdr) {
    if (!hdr || hdr.getAttribute('data-bound')) return;
    hdr.setAttribute('data-bound', '1');
    var bar = hdr.querySelector('[data-hdr-bar]');
    var mq = window.matchMedia('(min-width: 990px)');
    var sticky = hdr.getAttribute('data-sticky');

    // ---- height vars (used by the hero slider + sticky elements)
    function writeHeight() {
      var h = Math.round(bar.getBoundingClientRect().height);
      root.style.setProperty('--lx-header-h', h + 'px');
      document.body.style.setProperty('--header-height', (sticky === 'none' ? 0 : h) + 'px');
      document.body.style.setProperty('--header-group-height', h + 'px');
    }
    if ('ResizeObserver' in window) new ResizeObserver(writeHeight).observe(bar);
    writeHeight();

    // ---- scroll state
    var last = window.scrollY, ticking = false, drawerActive = false;
    function onScroll() {
      ticking = false;
      var y = window.scrollY;
      hdr.toggleAttribute('data-scrolled', y > 8);
      if (sticky === 'scroll-up') {
        var delta = y - last;
        if (Math.abs(delta) > 4) hdr.toggleAttribute('data-hidden', delta > 0 && y > 180 && !hdr.hasAttribute('data-open') && !drawerActive);
        if (y < 10) hdr.removeAttribute('data-hidden');
      }
      last = y;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();

    // ---- desktop mega menu (hover intent + click/keyboard)
    var items = Array.prototype.slice.call(hdr.querySelectorAll('[data-menu-item]'));
    var openItem = null, openTimer, closeTimer;
    function linkOf(item) { return item.querySelector('.lx-nav__link'); }
    function open(item) {
      clearTimeout(closeTimer);
      if (openItem === item) return;
      if (openItem) close(false);
      item.classList.add('is-open');
      var l = linkOf(item); if (l) l.setAttribute('aria-expanded', 'true');
      openItem = item;
      hdr.toggleAttribute('data-open', item.classList.contains('lx-nav__item--mega'));
    }
    function close(all) {
      clearTimeout(openTimer);
      if (!openItem) return;
      openItem.classList.remove('is-open');
      var l = linkOf(openItem); if (l) l.setAttribute('aria-expanded', 'false');
      openItem = null;
      if (all !== false) hdr.removeAttribute('data-open');
    }
    items.forEach(function (item) {
      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !mq.matches) return;
        clearTimeout(closeTimer); clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : 90);
      });
      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { if (openItem === item) close(); }, 220);
      });
      var link = linkOf(item);
      if (link) {
        link.addEventListener('click', function (e) { if (openItem !== item) { e.preventDefault(); open(item); } });
        link.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowDown') { e.preventDefault(); open(item); var a = item.querySelector('[data-menu-panel] a'); if (a) a.focus(); }
        });
      }
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget) && openItem === item) close(); });
    });
    var scrim = hdr.querySelector('[data-scrim]');
    if (scrim) scrim.addEventListener('click', function () { close(); });
    document.addEventListener('click', function (e) { if (openItem && !openItem.contains(e.target)) close(); });

    // ---- cart button fallback when the theme has no cart drawer
    Array.prototype.forEach.call(hdr.querySelectorAll('[data-cart-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        if (!document.getElementById('cart-drawer')) window.location.href = settings.cartUrl || rootUrl() + 'cart';
      });
    });

    // ---- mobile drawer: horizontal scroll-snap sheet (swipe left to close)
    var drawer = hdr.querySelector('[data-drawer]');
    var scroller = hdr.querySelector('[data-drawer-scroller]');
    var sheet = hdr.querySelector('[data-drawer-sheet]');
    var openBtn = hdr.querySelector('[data-drawer-open]');
    var closeDrawer = function () {};
    if (drawer && scroller && sheet && openBtn) {
      var supportsInitialTarget = window.CSS && CSS.supports('scroll-initial-target', 'nearest');
      var supportsTimeline = window.CSS && CSS.supports('animation-timeline: scroll()');
      var state = 'closed';
      var closedLeft = function () { return scroller.scrollWidth - scroller.clientWidth; };
      var inertTargets = function () { return document.querySelectorAll('#MainContent, main, footer, [data-hdr-bar]'); };
      var frames = function () { return new Promise(function (r) { requestAnimationFrame(function () { requestAnimationFrame(r); }); }); };
      if (!supportsInitialTarget) scroller.scrollLeft = closedLeft();
      if (!supportsTimeline) {
        scroller.addEventListener('scroll', function () {
          var ratio = 1 - scroller.scrollLeft / (sheet.offsetWidth || 1);
          drawer.style.setProperty('--drawer-backdrop', String(Math.min(1, Math.max(0, ratio))));
        }, { passive: true });
      }
      var onOpened = function () {
        state = 'open';
        Array.prototype.forEach.call(inertTargets(), function (el) { el.inert = true; });
        openBtn.setAttribute('aria-expanded', 'true');
        sheet.focus({ preventScroll: true });
      };
      var onClosed = function () {
        var hadFocus = drawer.contains(document.activeElement);
        state = 'closed';
        drawerActive = false;
        drawer.classList.remove('is-active', 'is-open');
        Array.prototype.forEach.call(inertTargets(), function (el) { el.inert = false; });
        root.style.removeProperty('overflow');
        openBtn.setAttribute('aria-expanded', 'false');
        if (hadFocus) openBtn.focus({ preventScroll: true });
      };
      var visible = 1 / Math.max(window.innerWidth, 320);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var entry = entries[entries.length - 1];
          if (!entry || state === 'closed') return;
          if (entry.intersectionRatio < visible && state !== 'opening') onClosed();
          if (entry.intersectionRatio >= 0.99 && state === 'opening') onOpened();
        }, { root: drawer, threshold: [visible, 0.99, 1] }).observe(sheet);
      }
      var openDrawer = function () {
        if (state === 'open' || state === 'opening') return;
        state = 'opening';
        drawerActive = true;
        hdr.removeAttribute('data-hidden');
        drawer.classList.add('is-active');
        root.style.overflow = 'hidden';
        var go = function () {
          drawer.classList.add('is-open');
          scroller.scrollTo({ left: 0, behavior: 'auto' });
          setTimeout(function () { if (state === 'opening' && scroller.scrollLeft < 2) onOpened(); }, 450);
        };
        if (!supportsInitialTarget || scroller.scrollLeft < 2) {
          scroller.scrollTo({ left: closedLeft(), behavior: 'instant' });
          frames().then(go);
        } else { go(); }
      };
      closeDrawer = function () {
        if (state === 'closed') return;
        state = 'closing';
        scroller.scrollTo({ left: closedLeft(), behavior: 'auto' });
        setTimeout(function () { if (state === 'closing' && scroller.scrollLeft >= closedLeft() - 2) onClosed(); }, 500);
      };
      openBtn.addEventListener('click', openDrawer);
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-drawer-close]') || !sheet.contains(e.target)) closeDrawer();
      });
      mq.addEventListener('change', function (e) { if (e.matches && state !== 'closed') onClosed(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openItem) { var l = linkOf(openItem); close(); if (l) l.focus(); }
      closeDrawer();
    });
  }
  lx.headers = function (scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.lx-hdr'), initHeader);
  };

  /* =========================================================== footer */
  function initFooter(f) {
    if (!f || f.getAttribute('data-bound')) return;
    f.setAttribute('data-bound', '1');
    var top = f.querySelector('[data-to-top]');
    if (top) top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() { Array.prototype.forEach.call(f.querySelectorAll('[data-foot-acc]'), function (d) { d.open = !mq.matches; }); }
    sync();
    mq.addEventListener('change', sync);
  }
  lx.footers = function (scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.lx-foot'), initFooter);
  };

  /* =========================================================== init */
  function init(scope) {
    lx.headers(scope);
    lx.sliders(scope);
    lx.footers(scope);
    lx.carousels(scope);
    lx.tabs(scope);
    lx.reveal(scope);
  }
  lx.init = init;
  if (motion) root.classList.add('lx-motion', 'lx-reveal-up');
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.lxReady = true;
})();
/* BEME "Liquid Glass" JS v3.0 — one file for all sections. No dependencies. */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };

  /* ---------- unified panel system (sheets, drawers, spotlight) ---------- */
  var overlay = $("[data-b-overlay]");
  var openPanel = null;

  function open(name) {
    var p = $('[data-b-panel="' + name + '"]');
    if (!p) return;
    close(true);
    p.hidden = false;
    if (overlay) overlay.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        p.classList.add("is-open");
        if (overlay) overlay.classList.add("is-open");
      });
    });
    document.body.style.overflow = "hidden";
    openPanel = p;
    if (name === "search") { var f = $("input[type=search]", p); if (f) setTimeout(function () { f.focus(); }, 120); }
    $$('[data-b-open="' + name + '"]').forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
  }

  function close(instant) {
    if (!openPanel) return;
    var p = openPanel;
    openPanel = null;
    p.classList.remove("is-open");
    if (overlay) overlay.classList.remove("is-open");
    document.body.style.overflow = "";
    var done = function () {
      if (!p.classList.contains("is-open")) p.hidden = true;
      if (overlay && !overlay.classList.contains("is-open")) overlay.hidden = true;
    };
    instant === true ? done() : setTimeout(done, 400);
    $$("[data-b-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }

  document.addEventListener("click", function (e) {
    var o = e.target.closest("[data-b-open]");
    if (o) { e.preventDefault(); open(o.getAttribute("data-b-open")); return; }
    if (e.target.closest("[data-b-close]")) { e.preventDefault(); close(); return; }
    if (overlay && e.target === overlay) close();
    if (openPanel && openPanel.classList.contains("b-spot") && e.target === openPanel) close();
    if (openPanel && openPanel.classList.contains("b-sheet") && e.target === openPanel) close();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });

  /* ---------- bottom-sheet drag to close ---------- */
  $$("[data-b-drag]").forEach(function (handle) {
    var sheet = handle.closest(".b-sheet, .b-drawer");
    var panel = handle.closest(".b-sheet__panel") || sheet;
    if (!sheet || !panel) return;
    var startY = 0, dy = 0, dragging = false;
    handle.addEventListener("pointerdown", function (e) {
      dragging = true; startY = e.clientY; dy = 0;
      sheet.classList.add("is-dragging");
      handle.setPointerCapture(e.pointerId);
    });
    handle.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = "translateY(" + dy + "px)";
    });
    var end = function () {
      if (!dragging) return;
      dragging = false;
      sheet.classList.remove("is-dragging");
      panel.style.transform = "";
      if (dy > 90) close();
    };
    handle.addEventListener("pointerup", end);
    handle.addEventListener("pointercancel", end);
    handle.addEventListener("click", function () { if (dy < 8) close(); });
  });

  /* ---------- fixed pill header (CSS sticky can't escape Horizon's #header-group,
     so we pin with position:fixed past the header's natural offset + a spacer) ---------- */
  var headwrap = $("[data-b-header]");
  if (headwrap) {
    var sticky = headwrap.classList.contains("is-sticky");
    var spacer = document.createElement("div");
    var headTop = 0;
    if (sticky) headwrap.after(spacer);
    var measure = function () {
      if (!sticky) return;
      var wasFixed = headwrap.classList.contains("is-fixed");
      if (wasFixed) { headwrap.classList.remove("is-fixed"); spacer.style.height = "0px"; }
      headTop = headwrap.getBoundingClientRect().top + window.scrollY;
      if (wasFixed) apply();
    };
    var transparent = headwrap.classList.contains("b-headwrap--transparent");
    if (transparent) {
      var annEl = $("[data-b-announce]");
      var setAnnH = function () {
        headwrap.style.setProperty("--b-ann-h", (annEl ? annEl.offsetHeight : 0) + "px");
      };
      setAnnH();
      window.addEventListener("resize", setAnnH, { passive: true });
    }
    var lastY = 0;
    var apply = function () {
      var y = window.scrollY;
      var fixNow = sticky && y > headTop + (transparent ? headwrap.offsetHeight + 40 : 0);
      if (fixNow !== headwrap.classList.contains("is-fixed")) {
        if (!transparent) spacer.style.height = fixNow ? headwrap.offsetHeight + "px" : "0px";
        headwrap.classList.toggle("is-fixed", fixNow);
      }
      headwrap.classList.toggle("is-scrolled", y > headTop + 4);
      if (headwrap.classList.contains("b-headwrap--smart")) {
        if (Math.abs(y - lastY) > 4) {
          headwrap.setAttribute("data-scroll-direction", y > lastY ? "down" : "up");
          lastY = y;
        }
      }
    };
    var tick = false;
    window.addEventListener("scroll", function () {
      if (tick) return;
      tick = true;
      requestAnimationFrame(function () { apply(); tick = false; });
    }, { passive: true });
    window.addEventListener("resize", measure, { passive: true });
    measure(); apply();
  }

  /* ---------- mega menu tabs (Ronin tabbed layout) ---------- */
  document.addEventListener("click", function (e) {
    var tab = e.target.closest("[data-b-tab]");
    if (!tab) return;
    e.preventDefault();
    var mega = tab.closest(".b-mega");
    var id = tab.getAttribute("data-b-tab");
    $$("[data-b-tab]", mega).forEach(function (t) { t.classList.toggle("is-active", t === tab); });
    $$("[data-b-tabpanel]", mega).forEach(function (p) { p.classList.toggle("is-active", p.getAttribute("data-b-tabpanel") === id); });
  });

  /* ---------- announcement rotation ---------- */
  $$("[data-b-announce]").forEach(function (bar) {
    var items = $$(".b-announce__item", bar);
    if (items.length < 2) return;
    var i = 0, ms = parseInt(bar.dataset.interval, 10) || 4000;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, ms);
  });

  /* ---------- predictive search (any [data-b-search] wrapper) ---------- */
  $$("[data-b-search]").forEach(function (wrap) {
    var sInput = $("[data-b-search-input]", wrap);
    var sResults = $("[data-b-search-results]", wrap);
    if (!sInput || !sResults) return;
    var t;
    sInput.addEventListener("input", function () {
      clearTimeout(t);
      var q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ""; return; }
      t = setTimeout(function () {
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var prods = (d.resources && d.resources.results.products) || [];
            sResults.innerHTML = prods.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=92" width="46" height="46" alt="" loading="lazy">' : "";
              return '<a class="b-sresult" href="' + p.url + '">' + img + '<span><span class="b-sresult__t">' + p.title + '</span><br><span class="b-sresult__p">' + p.price + "</span></span></a>";
            }).join("") + (prods.length ? '<a class="b-sresult b-sresult--all" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>' : "");
          })["catch"](function () {});
      }, 250);
    });
  });

  /* ---------- AJAX cart ---------- */
  var CartAPI = {
    root: function () { return $("[data-b-cart]"); },
    busy: function (on) { var c = this.root(); if (c) c.classList.toggle("is-loading", on); },

    refresh: function (thenOpen) {
      var c = this.root();
      if (!c) return Promise.resolve();
      var sid = c.dataset.sectionId;
      return fetch(window.location.pathname + "?sections=" + sid)
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var html = json[sid];
          if (!html) return;
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = $("[data-b-cart-inner]", tmp);
          var cur = $("[data-b-cart-inner]", c);
          if (fresh && cur) cur.replaceWith(fresh);
          return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
            $$("[data-cart-count]").forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle("is-empty", cart.item_count === 0);
              el.classList.remove("b-pop");
              void el.offsetWidth;
              el.classList.add("b-pop");
            });
            var lbl = $("[data-cart-count-label]", c);
            if (lbl) lbl.textContent = "(" + cart.item_count + ")";
          });
        })
        .then(function () { CartAPI.busy(false); if (thenOpen) open("cart"); })
        ["catch"](function () { CartAPI.busy(false); });
    },

    change: function (line, qty) {
      this.busy(true);
      return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () { return CartAPI.refresh(); });
    },

    add: function (variantId, qty) {
      this.busy(true);
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 })
      }).then(function () { return CartAPI.refresh(true); });
    }
  };
  window.BemeCart = CartAPI; /* public API: BemeCart.add(variantId), BemeCart.refresh(true) */

  /* ---------- fly-to-cart animation ---------- */
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function flyToCart(sourceBtn) {
    if (reduceMotion || !sourceBtn) return Promise.resolve();
    var scope = sourceBtn.closest(".b-pcard, .b-upsell__row, form, section, main") || document;
    var img = scope.querySelector("img");
    var cartBtn = null;
    $$('[data-b-open="cart"]').forEach(function (b) { if (b.offsetParent) cartBtn = cartBtn || b; });
    if (!img || !cartBtn || !img.src) return Promise.resolve();
    var a = img.getBoundingClientRect(), b = cartBtn.getBoundingClientRect();
    if (!a.width || !b.width) return Promise.resolve();
    var size = Math.min(a.width, a.height, 92);
    var clone = document.createElement("img");
    clone.src = img.currentSrc || img.src;
    clone.className = "b-fly";
    clone.style.cssText = "left:" + (a.left + a.width / 2 - size / 2) + "px;top:" + (a.top + a.height / 2 - size / 2) + "px;width:" + size + "px;height:" + size + "px;";
    document.body.appendChild(clone);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = clone.animate([
      { transform: "translate(0,0) scale(1)", opacity: 1 },
      { transform: "translate(" + dx * 0.5 + "px," + (dy * 0.5 - 70) + "px) scale(.6)", opacity: .95, offset: .55 },
      { transform: "translate(" + dx + "px," + dy + "px) scale(.12)", opacity: .4 }
    ], { duration: 620, easing: "cubic-bezier(.3,.75,.45,1)" });
    return anim.finished.catch(function () {}).then(function () {
      clone.remove();
      var count = cartBtn.querySelector("[data-cart-count]");
      if (count) { count.classList.remove("b-pop"); void count.offsetWidth; count.classList.add("b-pop"); }
    });
  }
  window.BemePanel = { open: open, close: close };

  document.addEventListener("click", function (e) {
    var line = e.target.closest(".b-card[data-line], .b-line");
    var qbtn = e.target.closest("[data-b-qty]");
    if (qbtn && line) {
      var input = $("[data-b-qty-input]", line);
      var q = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qbtn.dataset.bQty, 10));
      input.value = q; /* optimistic — UI updates instantly */
      CartAPI.change(parseInt(line.dataset.line, 10), q);
      return;
    }
    if (e.target.closest("[data-b-remove]") && line) {
      CartAPI.change(parseInt(line.dataset.line, 10), 0);
      return;
    }
    var add = e.target.closest("[data-b-add]");
    if (add) {
      e.preventDefault();
      add.disabled = true;
      var fly = flyToCart(add);
      var req = fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(add.dataset.bAdd, 10), quantity: 1 })
      }).then(function () { CartAPI.busy(true); return CartAPI.refresh(false); });
      Promise.all([fly, req]).then(function () { open("cart"); add.disabled = false; });
    }
  });

  document.addEventListener("change", function (e) {
    if (e.target.matches("[data-b-qty-input]")) {
      var line = e.target.closest(".b-card[data-line], .b-line");
      CartAPI.change(parseInt(line.dataset.line, 10), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
  });

  /* ---------- Horizon bridge ----------
     Horizon buy buttons add to cart via internal fetch + custom events; sync our drawer.
     Also set --header-height vars Horizon's layout script expects. */
  var hzT;
  ["cart:update", "cart:change", "cart:refresh", "cart:added", "on:cart:add", "variant:add"].forEach(function (ev) {
    document.addEventListener(ev, function () {
      clearTimeout(hzT);
      hzT = setTimeout(function () { CartAPI.refresh(true); }, 60);
    });
  });
  function setHeaderVars() {
    if (!headwrap) return;
    var a = $("[data-b-announce]");
    document.body.style.setProperty("--header-height", headwrap.offsetHeight + "px");
    document.body.style.setProperty("--header-group-height", (headwrap.offsetHeight + (a ? a.offsetHeight : 0)) + "px");
  }
  setHeaderVars();
  window.addEventListener("resize", setHeaderVars, { passive: true });

  /* ---------- card color swatches: swap card image ---------- */
  document.addEventListener("click", function (e) {
    var sw = e.target.closest("[data-b-swatch]");
    if (!sw || !sw.dataset.img) return;
    e.preventDefault();
    var card = sw.closest(".b-pcard");
    var img = card && card.querySelector("[data-b-cardimg]");
    if (!img) return;
    img.src = sw.dataset.img;
    if (sw.dataset.srcset) img.srcset = sw.dataset.srcset;
    var act = card.querySelector(".b-swatch.is-active");
    if (act) act.classList.remove("is-active");
    sw.classList.add("is-active");
  });

  /* ---------- order note (debounced save) + clear cart ---------- */
  var noteT;
  document.addEventListener("input", function (e) {
    if (!e.target.matches("[data-b-note]")) return;
    clearTimeout(noteT);
    var v = e.target.value;
    noteT = setTimeout(function () {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ note: v })
      }).catch(function () {});
    }, 500);
  });
  document.addEventListener("click", function (e) {
    if (!e.target.closest("[data-b-clear]")) return;
    CartAPI.busy(true);
    fetch("/cart/clear.js", { method: "POST" }).then(function () { return CartAPI.refresh(); });
  });

  /* warm the cart section on first hover/touch of any cart button (fast first open) */
  var warmed = false;
  ["mouseenter", "touchstart"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (warmed || !e.target.closest || !e.target.closest('[data-b-open="cart"]')) return;
      warmed = true;
      var c = CartAPI.root();
      if (c) fetch(window.location.pathname + "?sections=" + c.dataset.sectionId).catch(function(){});
    }, { passive: true, capture: true });
  });

  /* ---------- hero slider: autoplay, dots, arrows, JIT warm ---------- */
  $$("[data-b-hero]").forEach(function (hero) {
    var track = $("[data-b-hero-track]", hero);
    if (!track) return;
    var slides = $$(".b-hero__slide", track);
    if (slides.length < 2) return;
    var dots = $$("[data-b-hero-dot]", hero);
    var idx = 0, timer = null, speed = parseInt(hero.dataset.speed, 10) || 5000;

    function go(i, instant) {
      idx = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: instant ? "auto" : "smooth" });
    }
    /* observe which slide is visible -> sync dots + warm the NEXT slide's image */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.intersectionRatio < 0.55) return;
        idx = slides.indexOf(en.target);
        dots.forEach(function (d, i) { d.classList.toggle("is-active", i === idx); });
        var next = slides[(idx + 1) % slides.length];
        var img = next && next.querySelector("img[loading=lazy]");
        if (img) img.loading = "eager";
      });
    }, { root: track, threshold: 0.55 });
    slides.forEach(function (s) { io.observe(s); });

    dots.forEach(function (d) {
      d.addEventListener("click", function () { go(parseInt(d.dataset.bHeroDot, 10)); restart(); });
    });
    var prev = $("[data-b-hero-prev]", hero), next = $("[data-b-hero-next]", hero);
    if (prev) prev.addEventListener("click", function () { go(idx - 1); restart(); });
    if (next) next.addEventListener("click", function () { go(idx + 1); restart(); });

    var auto = hero.dataset.autoplay === "true" && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    function start() { if (auto && !timer) timer = setInterval(function () { go(idx + 1); }, speed); }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { stop(); start(); }
    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", start);
    hero.addEventListener("touchstart", stop, { passive: true });
    hero.addEventListener("touchend", function () { setTimeout(start, 3000); }, { passive: true });
    document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });
    start();
  });

  /* ---------- collection: AJAX filters, sort, pagination ---------- */
  var colRoot = $("[data-b-col]");
  if (colRoot) {
    var colForm = $("[data-b-filter]", colRoot);
    var colBusy = false;

    function colFetch(url, scroll) {
      if (colBusy) return;
      colBusy = true;
      colRoot.classList.add("is-loading");
      var sid = colRoot.dataset.sectionId;
      var u = new URL(url, window.location.origin);
      u.searchParams.set("section_id", sid);
      fetch(u.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = tmp.querySelector("[data-b-col]");
          if (fresh) {
            colRoot.innerHTML = fresh.innerHTML;
            colForm = $("[data-b-filter]", colRoot);
          }
          var clean = new URL(url, window.location.origin);
          clean.searchParams.delete("section_id");
          history.pushState({}, "", clean.toString());
          if (scroll) colRoot.scrollIntoView({ behavior: "smooth", block: "start" });
        })
        ["finally"](function () {
          colBusy = false;
          colRoot.classList.remove("is-loading");
        });
    }

    function colSubmit() {
      if (!colForm) return;
      var fd = new FormData(colForm);
      var params = new URLSearchParams();
      fd.forEach(function (v, k) { if (v !== "") params.append(k, v); });
      colFetch(colForm.getAttribute("action") + "?" + params.toString(), false);
    }

    var priceT;
    document.addEventListener("change", function (e) {
      if (!colRoot.contains(e.target)) return;
      if (e.target.matches("[data-b-sort]")) { colSubmit(); return; }
      if (e.target.matches("[data-b-price]")) { clearTimeout(priceT); priceT = setTimeout(colSubmit, 600); return; }
      if (e.target.matches('.b-filters input[type="checkbox"]')) {
        /* live-apply on desktop; on mobile wait for "Show results" */
        if (window.matchMedia("(min-width: 990px)").matches) colSubmit();
      }
    });

    document.addEventListener("click", function (e) {
      if (!colRoot.contains(e.target)) return;
      var link = e.target.closest("[data-b-filter-link], [data-b-page]");
      if (link) {
        e.preventDefault();
        colFetch(link.getAttribute("href"), link.hasAttribute("data-b-page"));
      }
    });

    document.addEventListener("submit", function (e) {
      if (e.target === colForm) { e.preventDefault(); colSubmit(); close(); }
    });

    window.addEventListener("popstate", function () {
      colFetch(window.location.href, false);
    });
  }

  /* ---------- product page: variants, gallery, buy now, sticky bar ---------- */
  var pp = $("[data-b-product]");
  if (pp) {
    var vdataEl = $("[data-b-variants]", pp);
    var variants = vdataEl ? JSON.parse(vdataEl.textContent) : [];
    var moneyFmt = ($("[data-b-money]", pp) ? JSON.parse($("[data-b-money]", pp).textContent) : "Rs.{{amount}}");
    function money(cents) {
      var n = (cents / 100).toFixed(2).replace(/\.00$/, "");
      n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return moneyFmt.replace(/\{\{\s*amount[^}]*\}\}/, n).replace(/0([.,]00)?$/, function (m) { return m === "0" ? n : m; });
    }
    /* simpler: derive prefix/suffix from formatted zero */
    var zeroParts = moneyFmt.split(/0(?:[.,]00)?/);
    function fmt(cents) {
      var n = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return (zeroParts[0] || "") + n + (zeroParts[1] || "");
    }

    function selectedOptions() {
      return $$("[data-b-opt]", pp).map(function (f) {
        var ch = $("input:checked, select", f);
        return ch ? ch.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function showMedia(id) {
      if (!id) return;
      $$("[data-b-frame]", pp).forEach(function (f) { f.classList.toggle("is-active", f.dataset.bFrame == id); });
      $$("[data-b-thumb]", pp).forEach(function (t) {
        var on = t.dataset.bThumb == id;
        t.classList.toggle("is-active", on);
        if (on) t.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
      });
    }
    function applyVariant(v) {
      if (!v) return;
      var idInput = $("[data-b-variant-id]", pp);
      if (idInput) idInput.value = v.id;
      var now = $("[data-b-price-now]", pp), was = $("[data-b-price-was]", pp), save = $("[data-b-price-save]", pp);
      if (now) now.textContent = fmt(v.price);
      var onSale = v.cap > v.price;
      if (was) { was.hidden = !onSale; if (onSale) was.textContent = fmt(v.cap); }
      if (save) { save.hidden = !onSale; if (onSale) save.textContent = "You save " + fmt(v.cap - v.price); }
      var badge = $("[data-b-pp-badge]", pp);
      if (badge) {
        if (onSale) { badge.hidden = false; badge.textContent = "-" + Math.round((v.cap - v.price) * 100 / v.cap) + "%"; }
        else badge.hidden = true;
      }
      var atc = $("[data-b-pp-atc]", pp), lbl = $("[data-b-atc-label]", pp);
      if (atc) atc.disabled = !v.available;
      if (lbl) lbl.textContent = v.available ? (atc.dataset.label || lbl.dataset.a || lbl.textContent.replace("Sold Out", "Add to Cart")) : "Sold Out";
      var barP = $("[data-b-bar-price]", pp), barA = $("[data-b-bar-atc]", pp);
      if (barP) barP.textContent = fmt(v.price);
      if (barA) barA.disabled = !v.available;
      $$("[data-b-opt]", pp).forEach(function (f) {
        var out = $("[data-b-opt-value]", f), ch = $("input:checked, select", f);
        if (out && ch) out.textContent = ch.value;
      });
      showMedia(v.media);
      try {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      } catch (err) {}
    }

    pp.addEventListener("change", function (e) {
      if (e.target.matches("[data-b-opt-input]")) applyVariant(findVariant(selectedOptions()));
    });
    /* addons: reveal personalization field; letters-only live validation */
    pp.addEventListener("change", function (e) {
      var chk = e.target.closest("[data-b-addon-check]");
      if (chk) {
        var root = chk.closest("[data-b-addon]");
        var field = $("[data-b-addon-field]", root);
        if (field) field.hidden = !chk.checked;
        var vars = $("[data-b-addon-variants]", root);
        if (vars) vars.hidden = !chk.checked;
      }
      var vr = e.target.closest("[data-b-addon-vradio]");
      if (vr) {
        var root2 = vr.closest("[data-b-addon]");
        var chk2 = $("[data-b-addon-check]", root2);
        if (chk2) chk2.dataset.variant = vr.value;
        var name = $("[data-b-addon-vname]", root2);
        var img = vr.nextElementSibling;
        if (name && img) name.textContent = img.alt || img.textContent || "";
      }
    });
    /* anchor tabs: smooth scroll */
    pp.addEventListener("click", function (e) {
      var a = e.target.closest("[data-b-anchor]");
      if (!a) return;
      var t = document.querySelector(a.getAttribute("href"));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
    pp.addEventListener("input", function (e) {
      if (e.target.matches("[data-b-addon-text]")) {
        e.target.value = e.target.value.replace(/[^A-Za-z ]/g, "");
      }
    });
    function ppItems() {
      var form = $("[data-b-pp-form]", pp);
      var qty = parseInt(($('input[name="quantity"]', form) || {}).value, 10) || 1;
      var items = [{ id: parseInt($("[data-b-variant-id]", form).value, 10), quantity: qty }];
      $$("[data-b-addon]", pp).forEach(function (a) {
        var chk = $("[data-b-addon-check]", a);
        if (!chk || !chk.checked) return;
        var item = { id: parseInt(chk.dataset.variant, 10), quantity: 1 };
        var txt = $("[data-b-addon-text]", a);
        if (txt && txt.value.trim()) {
          var props = {};
          props[txt.dataset.prop || "Personalization"] = txt.value.trim();
          item.properties = props;
        }
        items.push(item);
      });
      return items;
    }
    function ppAdd() {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: ppItems() })
      });
    }
    /* own submit handler (capture) so addons ride along as extra line items */
    document.addEventListener("submit", function (e) {
      var f = e.target;
      if (!pp.contains(f) || !f.matches("[data-b-pp-form]")) return;
      e.preventDefault();
      e.stopPropagation();
      var btn = $("[data-b-pp-atc]", pp);
      var lbl = $("[data-b-atc-label]", pp);
      var orig = lbl ? lbl.textContent : "";
      if (btn) { btn.disabled = true; btn.classList.add("is-adding"); }
      var fly = (typeof flyToCart === "function") ? flyToCart(btn) : Promise.resolve();
      var req = ppAdd().then(function () { CartAPI.busy(true); return CartAPI.refresh(false); });
      Promise.all([fly, req]).then(function () {
        if (btn) {
          btn.classList.remove("is-adding");
          btn.classList.add("is-added");
          if (lbl) lbl.textContent = "✓ Added";
          setTimeout(function () {
            btn.classList.remove("is-added");
            if (lbl) lbl.textContent = orig;
            btn.disabled = false;
          }, 1400);
        }
        open("cart");
      });
    }, true);

    pp.addEventListener("click", function (e) {
      var th = e.target.closest("[data-b-thumb]");
      if (th) showMedia(th.dataset.bThumb);
      var pq = e.target.closest("[data-b-pq]");
      if (pq) {
        var inp = $('input[name="quantity"]', pp);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(pq.dataset.bPq, 10));
      }
      var bn = e.target.closest("[data-b-buynow]");
      if (bn) {
        bn.disabled = true;
        bn.classList.add("is-adding");
        ppAdd()
          .then(function () { window.location.href = "/checkout"; })
          ["catch"](function () { bn.disabled = false; bn.classList.remove("is-adding"); });
      }
      var ba = e.target.closest("[data-b-bar-atc]");
      if (ba) {
        var f2 = $("[data-b-pp-form]", pp);
        if (f2) f2.requestSubmit ? f2.requestSubmit() : f2.submit();
      }
    });

    /* sticky bar visibility */
    var bar = $("[data-b-ppbar]", pp);
    var mainAtc = $("[data-b-pp-atc]", pp);
    if (bar && mainAtc && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) {
        bar.classList.toggle("is-show", !en[0].isIntersecting && window.scrollY > 300);
      }, { threshold: 0 }).observe(mainAtc);
    }
  }

  /* ---------- product description read-more ---------- */
  document.addEventListener("click", function (e) {
    var m = e.target.closest("[data-beme-pd-more]");
    if (!m) return;
    var body = $("[data-beme-pd]");
    if (!body) return;
    var open = body.classList.toggle("is-open");
    m.textContent = open ? "Read less" : "Read more";
  });

  /* ---------- footer: back-to-top + mobile accordions ---------- */
  var topBtn = $("[data-b-top]");
  if (topBtn) {
    topBtn.hidden = false;
    var tT = false;
    window.addEventListener("scroll", function () {
      if (tT) return;
      tT = true;
      requestAnimationFrame(function () {
        topBtn.classList.toggle("is-show", window.scrollY > 500);
        tT = false;
      });
    }, { passive: true });
    topBtn.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
  if (window.matchMedia("(max-width: 767px)").matches) {
    $$("details.b-foot__col[open]").forEach(function (d) { d.removeAttribute("open"); });
  }

  /* Intercept standard product forms so adds open our drawer.
     Add data-b-native to any form to keep default behavior. */
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f.matches('form[action*="/cart/add"]:not([data-b-native])') && CartAPI.root()) {
      e.preventDefault();
      var btn = $('[type="submit"]', f) || f;
      if (btn.disabled !== undefined) btn.disabled = true;
      var fly = flyToCart(btn);
      var req = fetch("/cart/add.js", { method: "POST", body: new FormData(f) })
        .then(function () { CartAPI.busy(true); return CartAPI.refresh(false); });
      Promise.all([fly, req]).then(function () { open("cart"); if (btn.disabled !== undefined) btn.disabled = false; });
    }
  });
})();


  /* =========================================================== hero slider */
  /* Replaces everything from "hero slider" down to (not including) "header" in lx-premium.js */
  function initSlider(el) {
    if (!el || el.getAttribute('data-bound')) return;
    el.setAttribute('data-bound', '1');
    var track = el.querySelector('.ghs__track');
    var slides = Array.prototype.slice.call(el.querySelectorAll('.ghs__slide'));
    var dots = Array.prototype.slice.call(el.querySelectorAll('.ghs__dot'));
    var prevBtn = el.querySelector('[data-ghs-prev]');
    var nextBtn = el.querySelector('[data-ghs-next]');
    var n = slides.length;
    if (n < 2 || !track) return;

    var cur = 0, timer = null, leaveTimer = null, busy = false, ready = false, inView = false, hovering = false, editorHold = false;
    var autoplay = el.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(el.getAttribute('data-speed'), 10) || 5000;

    function wait(p, ms) { return Promise.race([p, new Promise(function (r) { setTimeout(r, ms); })]); }
    // Images of slides 2+ only load when needed (and only the desktop OR mobile version)
    function hydrate(s) {
      if (!s || s.getAttribute('data-loaded')) return Promise.resolve();
      s.setAttribute('data-loaded', '1');
      Array.prototype.forEach.call(s.querySelectorAll('source[data-srcset]'), function (src) {
        src.srcset = src.getAttribute('data-srcset');
        src.removeAttribute('data-srcset');
      });
      var img = s.querySelector('img');
      if (!img) return Promise.resolve();
      if (img.getAttribute('data-src')) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
      return img.decode ? img.decode().catch(function () {}) : Promise.resolve();
    }
    function canPlay() {
      return autoplay && ready && inView && !hovering && !editorHold && document.visibilityState === 'visible';
    }
    function restartProgress() {
      var dot = dots[cur];
      if (!dot) return;
      dot.classList.remove('is-active');
      void dot.offsetWidth;
      dot.classList.add('is-active');
    }
    function schedule() {
      clearTimeout(timer);
      if (canPlay()) {
        el.setAttribute('data-playing', '1');
        restartProgress();
        timer = setTimeout(function () { go(cur + 1, 1); }, speed);
      } else {
        el.setAttribute('data-playing', '0');
      }
    }
    function go(i, dir) {
      i = (i + n) % n;
      if (i === cur || busy) return;
      if (!dir) dir = i > cur ? 1 : -1;
      busy = true;
      clearTimeout(timer);
      var prev = slides[cur], next = slides[i];
      wait(hydrate(next), 4000).then(function () {
        // Direction drives the slide/parallax animation
        el.style.setProperty('--ghs-dir', dir);
        clearTimeout(leaveTimer);
        slides.forEach(function (s) { s.classList.remove('is-leaving'); });
        // Snap the incoming slide to its start position, then animate it in
        next.classList.add('is-prep');
        void next.offsetWidth;
        next.classList.remove('is-prep');

        prev.classList.remove('is-active'); prev.classList.add('is-leaving'); prev.setAttribute('aria-hidden', 'true');
        next.classList.add('is-active'); next.removeAttribute('aria-hidden');
        leaveTimer = setTimeout(function () { prev.classList.remove('is-leaving'); }, 950);

        var pl = prev.querySelector('.ghs__link'), nl = next.querySelector('.ghs__link');
        if (pl) pl.tabIndex = -1;
        if (nl) nl.removeAttribute('tabindex');
        if (dots[cur]) { dots[cur].classList.remove('is-active'); dots[cur].removeAttribute('aria-current'); }
        if (dots[i]) { dots[i].classList.add('is-active'); dots[i].setAttribute('aria-current', 'true'); }
        if (next.getAttribute('data-gradient')) el.style.setProperty('--ghs-g1', next.getAttribute('data-gradient'));
        cur = i;
        busy = false;
        if (ready) { hydrate(slides[(i + 1) % n]); hydrate(slides[(i - 1 + n) % n]); }
        schedule();
      });
    }

    // Arrows
    el.setAttribute('data-arrows-bound', '1');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(cur - 1, -1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(cur + 1, 1); });
    // Warm the neighbouring image as soon as the visitor aims at an arrow
    [prevBtn, nextBtn].forEach(function (b, k) {
      if (b) b.addEventListener('pointerenter', function () { hydrate(slides[(cur + (k ? 1 : -1) + n) % n]); });
    });

    // Dots
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(parseInt(dot.getAttribute('data-index'), 10)); });
    });

    // Keyboard (when focus is inside the slider)
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1, -1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1, 1); }
    });

    // Swipe (touch) + drag (mouse)
    var sx = 0, sy = 0, swiped = false, down = false;
    function swipeEnd(x, y) {
      var dx = x - sx, dy = y - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; go(cur + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1); }
    }
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; swiped = false; }, { passive: true });
    track.addEventListener('touchend', function (e) { swipeEnd(e.changedTouches[0].clientX, e.changedTouches[0].clientY); }, { passive: true });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('.ghs__arrow, .ghs__dot')) return;
      down = true; swiped = false; sx = e.clientX; sy = e.clientY;
    });
    track.addEventListener('pointerup', function (e) { if (down) { down = false; swipeEnd(e.clientX, e.clientY); } });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    track.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);

    // Pause conditions
    if (el.getAttribute('data-hover') === 'true') {
      track.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hovering = true; schedule(); } });
      track.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hovering = false; down = false; schedule(); } });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { inView = entries[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(track);
    } else { inView = true; }
    document.addEventListener('visibilitychange', schedule);

    // Autoplay starts only after the whole page has loaded
    function start() { ready = true; hydrate(slides[1]); hydrate(slides[n - 1]); schedule(); }
    function onLoaded() {
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 });
      else setTimeout(start, 300);
    }
    if (document.readyState === 'complete') onLoaded();
    else window.addEventListener('load', onLoaded, { once: true });
    el.__lxGo = function (idx) { editorHold = true; go(idx); };
    el.__lxRelease = function () { editorHold = false; schedule(); };
    el.__lxSlides = slides;
  }
  lx.sliders = function (scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.ghs'), initSlider);
  };
  document.addEventListener('shopify:block:select', function (e) {
    var slider = e.target.closest && e.target.closest('.ghs');
    if (slider && slider.__lxGo) slider.__lxGo(slider.__lxSlides.indexOf(e.target));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var slider = e.target.closest && e.target.closest('.ghs');
    if (slider && slider.__lxRelease) slider.__lxRelease();
  });

